import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { searchGraphUsers, getMyProfile } from '@/api/graphClient';
import { useDebounce } from '@/hooks/useDebounce';
import { queryKeys } from '@/utils/queryKeys';

export function useMyProfile(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.graph.myProfile,
    queryFn: getMyProfile,
    enabled,
    staleTime: Infinity,
  });
}

export function usePeopleSearch(search: string) {
  const debouncedSearch = useDebounce(search, 300);

  return useQuery({
    queryKey: queryKeys.graph.people(debouncedSearch),
    queryFn: () => searchGraphUsers(debouncedSearch),
    enabled: debouncedSearch.length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
